import React from 'react'
import { Select } from 'antd'
import { SelectProps as AntdSelectProps } from 'antd'
import clsx from 'clsx'
import styles from './index.module.scss'

export interface SelectCommonProps extends AntdSelectProps {
  rightContent?: React.ReactNode
  containerClassName?: string
}

export const SelectCommon = ({
  rightContent,
  className,
  containerClassName,
  ...props
}: SelectCommonProps) => {
  return (
    <div className={clsx(styles.selectCommonContainer, containerClassName)}>
      <Select
        style={{ width: '100%' }}
        className={clsx(styles.selectElement, className)}
        {...props}
      />
      {rightContent && (
        <div className={styles.rightContentWrapper}>
          {rightContent}
        </div>
      )}
    </div>
  )
}